import {
  ICancellationReason,
  ICancellationReasonApiModel,
  IGetCancellationReasonsApiResponse,
  IGetCancellationReasonsResult,
} from '../types';

const toCancellationReason = (model: ICancellationReasonApiModel): ICancellationReason => ({
  name: model.name,
  code: model.code,
});

const toGetCancellationReasonsResult = (
  response: IGetCancellationReasonsApiResponse,
): IGetCancellationReasonsResult => ({
  data: response.map(toCancellationReason),
});

export const CancellationReasonAdapters = {
  toCancellationReason,
  toGetCancellationReasonsResult,
};
